export function DatePicker({ label, value, optional, onChange }: { label: string; value: string; optional?: boolean; onChange: (value: string) => void }) {
  return <label>{label} {optional && <small>optional</small>}<input type="date" value={value} onChange={(e) => onChange(e.target.value)}/></label>;
}
